import { getStores } from "features/Stocks/api";
import { useAtom } from "jotai/index";
import { getProductGroups } from "features/ProductsGroup/api";
import {
  getReportsMovementRequest,
  getReportsProfitRequest,
} from "features/Reports/api/requests";

import { ItemsGroup, StoreItem } from "../types";
import { storesAtom } from "../atoms/storeAtom";
import { allItemsGroupsAtom } from "../atoms/itemAtom";
import {
  setInfoModalAtom,
  setLoadingModalAtom,
  setModalCloseAtom,
} from "../atoms/modalAtom/modalAtom";
import {
  reportsAtom,
  reportsFiltersAtom,
  reportsHeadersAtom,
} from "../atoms/reportsAtom";

const useReports = () => {
  const [stores, setStores] = useAtom(storesAtom);
  const [allItemsGroups, setAllItemsGroups] = useAtom(allItemsGroupsAtom);

  const [reports, setReports] = useAtom(reportsAtom);
  const [reportsHeaders, setReportsHeaders] = useAtom(reportsHeadersAtom);
  const [reportsFilters] = useAtom(reportsFiltersAtom);

  const [, setLoadingModal] = useAtom(setLoadingModalAtom);
  const [, setModalClose] = useAtom(setModalCloseAtom);
  const [, setInfoModal] = useAtom(setInfoModalAtom);
  const getReports = async (type: "profit" | "movement") => {
    setLoadingModal({});
    const getterFn =
      type === "movement" ? getReportsMovementRequest : getReportsProfitRequest;
    const data = await getterFn(reportsFilters);

    if (data && (data as any).message) {
      setInfoModal({ title: (data as any).message });
      return;
    }
    if (data && data.headers?.length) {
      setReports(data.tableData);
      setReportsHeaders(data.headers);
    }
    setModalClose();
  };

  const getAndSaveData = async () => {
    if (!stores?.length) {
      const storeData: StoreItem[] | void = await getStores();
      if (Array.isArray(storeData)) setStores(storeData);
    }

    if (!allItemsGroups?.length) {
      const itemsGroupsData: ItemsGroup[] | void =
        (await getProductGroups()) as ItemsGroup[];
      if (Array.isArray(itemsGroupsData)) setAllItemsGroups(itemsGroupsData);
    }
  };

  return { getReports, getAndSaveData };
};

export default useReports;
